import React from 'react';
import Header from './Header';
import Footer from './Footer';

// Define an array of services with the details
const servicesData = [
    {
        id: 1,
        title: 'Business Model Innovation',
        description: 'Business Model Innovation: We help businesses reinvent and optimize their business models, driving growth, innovation, and sustainability through strategic design and implementation.',
        image: require('../assets/images/service-icon76.png'),
    },
    {
        id: 2,
        title: 'Product/Service Development',
        description: 'We specialize in launching products and developing online stores, services, and e-commerce businesses, helping them thrive in the digital marketplace.',
        image: require('../assets/images/service-icon74.png'),
    },
    {
        id: 3,
        title: 'Market Research',
        description: 'Competitive Market Analysis to evaluate where your business stands to compete with similar businesses.',
        image: require('../assets/images/service-icon71.png'),
    },
    {
        id: 4,
        title: 'Strategic Planning',
        description: 'Growth , maintenance & long term revenue generation plan with financial analysis. Calendar schedule with pros & cons.',
        image: require('../assets/images/service-icon72.png'),
    },
    {
        id: 5,
        title: 'Partnership Development',
        description: 'We partner with companies and businesses to work hand-in-hand, driving growth through a collaborative work that maximizes leads and boosts revenue.',
        image: require('../assets/images/service-icon73.png'),
    },
    
    {
        id: 6,
        title: 'Business Optimization',
        description: 'Analyzing and optimizing business processes to improve efficiency, reduce costs, and enhance customer satisfaction.',
        image: require('../assets/images/service-icon75.png'),
    },
    
    {
        id: 7,
        title: 'Brand Launch',
        description: 'Branding, styling, and designing techniques to thrive as a unique business and create distinctive products in the market.',
        image: require('../assets/images/service-icon76.png'),
    },
    {
        id: 8,
        title: 'Networking',
        description: 'We connect entrepreneurs, businesses, and tech enthusiasts through our platform, fostering meaningful connections & increased networking.',
        image: require('../assets/images/service-icon76.png'),
    },
    {
        id: 9,
        title: 'Sales Outreach',
        description: 'Our sales team helps generate leads and creates an effective funnel system to maximize customer engagement.',
        image: require('../assets/images/service-icon76.png'),
    }
];


const serviceTechData = [
    {
        id: 1,
        title: 'Web Development',
        description: 'We design and develop custom websites that are visually stunning, user-friendly, and optimized for search engines. Our team uses the latest technologies to create fast, secure, and scalable websites.',
        image: require('../assets/images/service-icon71.png'),
    },
    {
        id: 2,
        title: 'App Development',
        description: 'We craft mobile apps that are intuitive, engaging, and meet your business goals. Our expertise spans iOS, Android, and cross-platform development.',
        image: require('../assets/images/service-icon72.png'),
    },
    {
        id: 3,
        title: 'Custom Software',
        description: 'Our team develops tailored software solutions that meet your unique business needs including CRM, HRM, ERP , All-in-One Stack Suite or any custom software that fits your business needs.',
        image: require('../assets/images/service-icon73.png'),
    },
    {
        id: 4,
        title: 'Artificial Intelligence',
        description: "We harness the power of AI to drive business growth and innovation. Our expertise includes machine learning, natural language processing, and computer vision. We'll help you integrate AI into your operations.",
        image: require('../assets/images/service-icon74.png'),
    },
    {
        id: 5,
        title: 'Digital Marketing',
        description: "We'll help you reach and engage your target audience through our digital marketing services. From SEO and PPC to social media and email marketing, we'll create a customized strategy that drives real results.",
        image: require('../assets/images/service-icon75.png'),
    },
    {
        id: 6,
        title: 'Graphics Designing',
        description: "Our team creates visually stunning graphics that capture your brand's essence. From logos and brochures to infographics and presentations, we create with style.",
        image: require('../assets/images/service-icon76.png'),
    },
    {
        id: 7,
        title: 'E-Commerce Development',
        description: 'We design and develop e-commerce websites that are secure, scalable, and optimized for conversions. Our team will help you create a seamless online shop.',
        image: require('../assets/images/service-icon76.png'),
    },
    {
        id: 8,
        title: 'Social Media Management',
        description: 'We build a strong social media presence that engages audience and drives real results. Our services include content creation, account management, and analytics reporting.',
        image: require('../assets/images/service-icon76.png'),
    },
    {
        id: 9,
        title: 'Product Videography',
        description: "Our team creates high-quality product videos that showcase your products in the best light. From explainer videos to product demos, we'll help you communicate your product's value.",
        image: require('../assets/images/service-icon76.png'),
    },
    // {
    //     id: 10,
    //     title: 'Artificial Intelligence and Machine Learning',
    //     description: 'Grursus mal suada faci ipsum and our the dolarorit ametion consectetur.',
    //     image: require('../assets/images/service-icon76.png'),
    // },
    // {
    //     id: 11,
    //     title: 'Internet of Things (IoT)',
    //     description: 'Grursus mal suada faci ipsum and our the dolarorit ametion consectetur.',
    //     image: require('../assets/images/service-icon76.png'),
    // },
    // {
    //     id: 12,
    //     title: 'Chat Bot',
    //     description: 'Grursus mal suada faci ipsum and our the dolarorit ametion consectetur.',
    //     image: require('../assets/images/service-icon76.png'),
    // },
];



const Services = () => {
    return (
        <>
            <Header />
            <section className="relative flex justify-center items-center bg-gradient-to-r from-black to-logo text-white md:py-24 py-12 w-full overflow-hidden">
                <div className="relative z-10 container mx-auto text-center md:px-24 px-6">
                    <h1 className="md:text-5xl text-2xl font-bold mb-4 animate-fadeIn">
                        Business Development Program
                    </h1>
                    <p className='md:w-[70%] mx-auto p-3'>
                        Elevate your business with our comprehensive B2B services, including business planning, maintenance, marketing, and software solutions.
                    </p>
                </div>
            </section>

            <div className='bg-'>
                <div className='container mx-auto w-full py-16 md:px-12 px-6'>
                    {/* <div className='flex flex-col justify-center items-center'>
                        <h2 className="text-3xl font-semibold mb-4">
                            Business Development Services
                        </h2>
                        <p className="text-lg mb-4 md:w-[80%] text-center">
                        Strategic analysis for the growth of online & manual businesses. Financial consultation, planning & VA assistance for business management. We streamline operations towards automation through software and optimize task management to cut cost & increase revenue.
                        </p>
                    </div> */}

                    {/* Map through servicesData array */}
                    <div className='grid md:grid-cols-3 grid-cols-1 gap-6'>
                        {servicesData.map(service => (
                            <div key={service.id} className='flex flex-col bg-white p-12 rounded-md hover:shadow-xl shadow-lg justify-center items-center'>
                                <img src={service.image} alt={service.title} />
                                <h2 className='text-xl text-center font-bold pb-3 pt-4'>{service.title}</h2>
                                <p className='text-center text-gray-500'>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='bg-'>
                <div className='container mx-auto w-full py-16 md:px-12 px-6'>
                    <div className='flex flex-col justify-center items-center'>
                        <h2 className="text-3xl font-semibold mb-4">
                            TECH SERVICES
                        </h2>
                        {/* <p className="text-lg mb-4 md:w-[80%] text-center">
                            Lorem Ipsum is simply dummy text of the printing and typesetting has been the industrys standard dummy text ever since
                        </p> */}
                    </div>

                    {/* Map through servicesData array */}
                    <div className='grid md:grid-cols-3 grid-cols-1 gap-6'>
                        {serviceTechData.map(service => (
                            <div key={service.id} className='flex flex-col bg-white p-12 rounded-md hover:shadow-xl shadow-lg justify-center items-center'>
                                <img src={service.image} alt={service.title} />
                                <h2 className='text-xl font-bold pb-3 pt-4'>{service.title}</h2>
                                <p className='text-center text-gray-500'>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Services;
